(function(){
  /* dots-sync v2: fully delegated (hydration-safe) — dots clickable + kept in
     sync with the active slide for every replo carousel on the page. */
  var DOT='[aria-label^="Go to slide"][role="button"]';
  function parts(root){
    return {
      track: root.querySelector('[data-replo-part="slide-track"]'),
      slides: Array.prototype.slice.call(root.querySelectorAll('[data-replo-part="slide"]')),
      dots: Array.prototype.slice.call(root.querySelectorAll(DOT))
    };
  }
  function activeIndex(p){
    var i=p.slides.findIndex(function(s){return s.getAttribute('data-is-active')==='true';});
    if(i>=0) return i;
    if(!p.track) return 0;
    var x=p.track.scrollLeft, best=0, dist=Infinity;
    p.slides.forEach(function(s,k){
      var d=Math.abs((s.offsetLeft-p.slides[0].offsetLeft)-x);
      if(d<dist){dist=d;best=k;}
    });
    return best;
  }
  function extrasOf(p){
    var cur=null, other=null;
    p.dots.forEach(function(d){
      if(d.getAttribute('aria-current')==='true'){ if(!cur) cur=d; }
      else if(!other) other=d;
    });
    var ex=[];
    if(cur&&other) cur.classList.forEach(function(c){ if(!other.classList.contains(c)) ex.push(c); });
    return ex;
  }
  var extrasCache={};
  function sync(root){
    var p=parts(root);
    if(!p.dots.length||p.slides.length<2) return;
    var key=root.getAttribute('data-rid')||'x';
    if(!(key in extrasCache)) extrasCache[key]=extrasOf(p);
    var ex=extrasCache[key];
    var i=activeIndex(p)%p.dots.length;
    p.dots.forEach(function(d,k){
      d.setAttribute('aria-current', k===i?'true':'false');
      ex.forEach(function(c){ d.classList.toggle(c, k===i); });
    });
  }
  /* dot click -> jump to that slide (document-level, survives hydration) */
  document.addEventListener('click', function(e){
    var dot=e.target&&e.target.closest?e.target.closest(DOT):null;
    if(!dot) return;
    var root=dot.closest('[data-replo-carousel="true"]');
    if(!root) return;
    var p=parts(root);
    var i=p.dots.indexOf(dot);
    if(i<0||!p.slides[i]||!p.track) return;
    e.preventDefault(); e.stopPropagation();
    p.slides.forEach(function(s,k){ s.setAttribute('data-is-active', k===i?'true':'false'); });
    p.track.scrollTo({left:p.slides[i].offsetLeft-p.slides[0].offsetLeft, behavior:'smooth'});
    sync(root);
  }, true);
  /* swipe / programmatic scroll -> settle then sync (capture catches non-bubbling scroll) */
  var timers=new WeakMap();
  document.addEventListener('scroll', function(e){
    var t=e.target;
    if(!t||!t.getAttribute||t.getAttribute('data-replo-part')!=='slide-track') return;
    var root=t.closest('[data-replo-carousel="true"]');
    if(!root) return;
    clearTimeout(timers.get(t));
    timers.set(t, setTimeout(function(){
      var p=parts(root);
      if(p.slides.length<2) return;
      var x=t.scrollLeft, best=0, dist=Infinity;
      p.slides.forEach(function(s,k){
        var d=Math.abs((s.offsetLeft-p.slides[0].offsetLeft)-x);
        if(d<dist){dist=d;best=k;}
      });
      p.slides.forEach(function(s,k){ s.setAttribute('data-is-active', k===best?'true':'false'); });
      sync(root);
    },160));
  }, true);
  /* nav-button clicks flip data-is-active -> mirror to dots (observe body, hydration-safe) */
  var mo=new MutationObserver(function(muts){
    var seen=new Set();
    muts.forEach(function(m){
      var root=m.target&&m.target.closest?m.target.closest('[data-replo-carousel="true"]'):null;
      if(root&&!seen.has(root)){ seen.add(root); sync(root); }
    });
  });
  mo.observe(document.body,{subtree:true,attributes:true,attributeFilter:['data-is-active']});
  /* cursor via stylesheet so it survives re-renders */
  var st=document.createElement('style');
  st.textContent='[data-replo-carousel="true"] '+DOT+'{cursor:pointer}';
  document.head.appendChild(st);
  /* initial sync passes: hydration may land late */
  [400,1500,3500].forEach(function(ms){
    setTimeout(function(){
      document.querySelectorAll('[data-replo-carousel="true"]').forEach(sync);
    },ms);
  });
})();

/* bb-plan-shim (transitional, 2026-08-17): corrects selling-plan / variant IDs
   at cart-add time while stale page-cache renders propagate. Remove once all
   pages serve the corrected forms. */
(function(){
  var path=location.pathname;
  function fixItem(it){
    var vid=String(it.id||''), plan=it.selling_plan?String(it.selling_plan):null;
    if(path.indexOf('/pages/revive-hair-glp1-support')===0){
      if(vid==='50140007661853'&&!plan)it.id=50620930294045;
      if(vid==='50140007661853'&&(plan==='690244878621'||!plan&&false))it.selling_plan=690652283165;
      if(vid==='50140007661853'&&plan==='690244878621')it.selling_plan=690652283165;
      if(vid==='50140007694621'&&(plan==='690652283165'||plan==='690244911389'||plan==='690244878621'))it.selling_plan=690652315933;
    }
    if(path.indexOf('/pages/hair-revive-gummies-native')===0){
      if((vid==='50140007661853'||vid==='50140007694621')&&plan==='690244878621')it.selling_plan=690652283165;
    }
    if(path.indexOf('/pages/acid-lp')===0||path.indexOf('/pages/bloomgummies2')===0||path.indexOf('/pages/revive-plus-mix-native')===0){
      if(vid==='50140007661853'&&!plan)it.id=50620930294045;
    }
    return it;
  }
  var of=window.fetch;
  window.fetch=function(){
    var a=arguments, u=(typeof a[0]==='string')?a[0]:(a[0]&&a[0].url)||'';
    if(/\/cart\/add(\.js)?(\?|$)/.test(u)){
      try{
        var opt=a[1]||{};
        if(typeof opt.body==='string'){
          var b=JSON.parse(opt.body);
          if(b.items)b.items=b.items.map(fixItem);
          else if(b.id){var f=fixItem({id:b.id,selling_plan:b.selling_plan});b.id=f.id;if(f.selling_plan)b.selling_plan=f.selling_plan;}
          opt.body=JSON.stringify(b); a[1]=opt;
        }else if(opt.body instanceof FormData){
          var it=fixItem({id:opt.body.get('id'),selling_plan:opt.body.get('selling_plan')});
          opt.body.set('id',String(it.id));
          if(it.selling_plan)opt.body.set('selling_plan',String(it.selling_plan));
        }
      }catch(e){}
    }
    return of.apply(this,a);
  };
})();
